"use client";

import { usePathname } from "next/navigation";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import { PredictorAuthProvider } from "@/contexts/PredictorAuthContext";

interface ClientLayoutWrapperProps {
  children: React.ReactNode;
}

export default function ClientLayoutWrapper({ children }: ClientLayoutWrapperProps) {
  const pathname = usePathname();

  // Determine which auth provider to use based on route
  const isPredictorRoute = pathname?.startsWith('/predictor');
  const isAdminRoute = pathname?.startsWith('/admin');

  // Choose the right auth provider based on route
  const AuthProvider = isPredictorRoute ? PredictorAuthProvider : 
                      isAdminRoute ? AdminAuthProvider : 
                      AdminAuthProvider; // Default to admin for other routes

  return (
    <AuthProvider>
      {children}
    </AuthProvider>
  );
}